import { ActionType } from "../interfaces/flow/action/ActionType";
import { WebRequestAction } from "../interfaces/flow/action/WebRequestAction";
import { v4 as uuidv4 } from "uuid";
import {produce} from "immer"
import { addJiraActionData } from "../../connections/atlassian/jira/jira.util";
import { isJira } from "../../connections/atlassian/ap";
import { Flow } from "../interfaces/flow/Flow";
import { getActions } from "../utils/integration.util";

export const newAction = (flow: Flow, name = "", parentId = undefined, uiRenderer = undefined): WebRequestAction => {
  let action = newWebAction(flow, name, parentId, uiRenderer);
  if (isJira()) {
    action = addJiraActionData(action);
  }
  return action;
};

const getOrderForNewAction = (flow: Flow, parentId: any = undefined) => {
  const siblings = getActions(flow, parentId);
  if (siblings && siblings.length > 0) {
    const siblingBefore = siblings[siblings.length - 1];
    return siblingBefore.order ? siblingBefore.order + 100 : 100;
  }
  return 100;
};

export const newWebAction = (flow: Flow, name = "", parentId = undefined, uiRenderer = undefined): WebRequestAction => {
  return {
    id: uuidv4(),
    name: name,
    parentId: parentId,
    type: ActionType.WEB_REQUEST_ACTION_TYPE,
    headers: [
      { key: "Content-Type", value: "application/json" },
      { key: "Connection", value: "keep-alive" },
      { key: "Accept-Encoding", value: "gzip, deflate, br" },
      { key: "Accept", value: "*/*" },
      { key: "User-Agent", value: "IntegrationsHub/cloud" },
      { key: "Cache-Control", value: "no-cache" },
    ],
    uiRenderer: uiRenderer,
    enabled: true,
    order: getOrderForNewAction(flow, parentId),
  };
};

export const duplicateWebAction = (action: WebRequestAction): WebRequestAction => {
  return produce(action, (draft) => {
    draft.id = uuidv4();
    draft.name = action.name + " (copy)";
  });
};
